import { useQuery } from '@tanstack/react-query';
import * as service from '../services';
import { useCurrentBaseTableStore } from '../CurrentBaseTable.store';
import { useState } from 'react';
import { TableRequestType } from '../types';
import { FiltersParamsEditBaseTableType } from '../../EditBaseTable/types';

const initialState = {
  page: 0,
  size: 20,
  uf: 'NACIONAL',
  descricao: [],
  familia: [],
  tier: [],
};

export const useTabelaBaseAtualList = () => {
  const { setCurrentBaseTableState, currentBaseTableSelectAll } = useCurrentBaseTableStore();
  const [tabelaBaseAtualParams, setTabelaBaseAtualParams] = useState<FiltersParamsEditBaseTableType>(initialState);
  const [tableData, setTableData] = useState({});

  const getTabelaBaseData = async (data: TableRequestType) => {
    const resp = await service.getTabelaBaseList(data);
    return resp;
  };

  const { isLoading, isError, data, error, isFetching, refetch } = useQuery({
    queryKey: ['tabela-base-atual-list', tabelaBaseAtualParams],
    queryFn: () => getTabelaBaseData(tabelaBaseAtualParams),
    retry: false,
    onSuccess: data => {
      setTableData(data);
      if (currentBaseTableSelectAll) {
        setCurrentBaseTableState('tabelaBaseItemsSelectedList', data.data?.content);
      }
    },
  });

  const handleChangeTabelaBaseAtualPage = (value: number) => {
    setTabelaBaseAtualParams({ ...tabelaBaseAtualParams, page: value - 1 });
  };

  const handleChangeTabelaBaseAtualLength = (value: number) => {
    setTabelaBaseAtualParams({ ...tabelaBaseAtualParams, page: 0, size: value });
  };

  return {
    isLoading,
    isError,
    tabelaBaseAtualData: data,
    error,
    isFetching,
    tableData,
    tabelaBaseAtualParams,
    setTableData,
    handleGetTabelaBaseAtual: refetch,
    setTabelaBaseAtualParams,
    handleChangeTabelaBaseAtualPage,
    handleChangeTabelaBaseAtualLength,
  };
};
